import React, { useState, useRef } from "react";
import "./ClaimModal.css";
import PlainButton from "../../../../../components/button/PlainButton";

interface ClaimModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  productName?: string;
}

const ClaimModal: React.FC<ClaimModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  productName,
}) => {
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [images, setImages] = useState<File[]>([]);
  const [previewUrls, setPreviewUrls] = useState<string[]>([]);
  const [contact, setContact] = useState("");
  const fileInputRef = useRef<HTMLInputElement>(null);

  if (!isOpen) return null;

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    setImages(files);
    setPreviewUrls(files.map((file) => URL.createObjectURL(file)));
  };

  const handleRemoveImage = (idx: number) => {
    const newImages = images.filter((_, i) => i !== idx);
    const newPreviews = previewUrls.filter((_, i) => i !== idx);
    setImages(newImages);
    setPreviewUrls(newPreviews);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      reason,
      details,
      images,
      contact,
      productName,
    });
    setReason("");
    setDetails("");
    setImages([]);
    setPreviewUrls([]);
    setContact("");
    if (fileInputRef.current) fileInputRef.current.value = "";
    onClose();
  };

  return (
    <div className="claim-modal-overlay">
      <div className="claim-modal-content">
        <button className="claim-modal-close" onClick={onClose}>
          &times;
        </button>
        <h2 className="claim-modal-title">File a Product Claim</h2>
        <form className="claim-modal-form" onSubmit={handleSubmit}>
          {productName && (
            <div className="claim-modal-form-group">
              <label>Product</label>
              <input type="text" value={productName} disabled />
            </div>
          )}
          <div className="claim-modal-form-group">
            <label>Reason for Claim</label>
            <select
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              required
              style={{ color: "#222" }}
            >
              <option value="">Select reason</option>
              <option value="damaged">Damaged Product</option>
              <option value="wrong">Wrong Product</option>
              <option value="missing">Missing Item</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div className="claim-modal-form-group">
            <label>Details</label>
            <textarea
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              placeholder="Describe your issue..."
              required
              rows={3}
            />
          </div>
          <div className="claim-modal-form-group">
            <label>Contact Info</label>
            <input
              type="text"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              placeholder="Your email or phone"
              required
            />
          </div>
          <div className="claim-modal-form-group">
            <label>Upload Images</label>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleImageChange}
              ref={fileInputRef}
            />
            <div className="claim-modal-thumbnails">
              {previewUrls.map((url, idx) => (
                <div className="claim-modal-thumb" key={idx}>
                  <img src={url} alt={`claim-img-${idx}`} />
                  <button
                    type="button"
                    className="claim-modal-thumb-remove"
                    onClick={() => handleRemoveImage(idx)}
                  >
                    &times;
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="claim-btn">
            <PlainButton text="Submit Claim" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ClaimModal;
